import React, { useState, useContext } from 'react';
import { ContextUser } from '../../../providers/ContextUser';
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  OutlinedInput,
  CircularProgress,
  Typography,
} from '@mui/material';

const Forgot = ({ handleAction }) => {
  const [requesting, setRequesting] = useState(false);
  const [fields, setFields] = useState({ email: '' });

  const { handleForgot } = useContext(ContextUser);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFields((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setRequesting(true);
    handleForgot(fields.email).finally(() => setRequesting(false));
  };

  return (
    <>
             <Box
         sx={{
           maxWidth: 400,
           width: '100%',
           background: 'rgba(255, 255, 255, 0.95)',
           backdropFilter: 'blur(20px)',
           padding: { xs: 2, md: 4 },
           borderRadius: 2,
           marginBottom: 2,
           boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
           border: '1px solid rgba(255, 255, 255, 0.2)',
           position: 'relative',
           zIndex: 1,
         }}
       >
        {/* Título do formulário */}
        <Box sx={{ textAlign: 'center', mb: 4 }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              color: '#1a1a2e',
              mb: 1,
            }}
          >
            Recuperar Senha
          </Typography>
          
          <Typography
            variant="body1"
            sx={{
              color: '#666',
              fontSize: '16px',
            }}
          >
            Digite seu email para receber o link de recuperação da SOLIS
          </Typography>
        </Box>

        <form onSubmit={handleSubmit}>
          <FormControl fullWidth margin='normal' variant='outlined'>
            <InputLabel htmlFor='email' shrink={!!fields.email}>Seu email</InputLabel>
            <OutlinedInput
              id='email'
              type='email'
              name='email'
              value={fields.email}
              onChange={handleChange}
              label='Seu email'
              notched={!!fields.email}
            />
          </FormControl>
          
          <Button
            type='submit'
            variant='contained'
            color='primary'
            fullWidth
            disabled={requesting}
            sx={{ mt: 3, mb: 2 }}
          >
            {requesting ? (
              <CircularProgress size={24} color='inherit' />
            ) : (
              'Enviar Link de Recuperação'
            )}
          </Button>
        </form>

        {/* Botão Retornar */}
        <Box sx={{ textAlign: 'center', mt: 3 }}>
          <Button
            variant='text'
            color='primary'
            onClick={() => handleAction('login')}
            sx={{
              textTransform: 'none',
              fontSize: '14px',
              fontWeight: 500,
              p: 0,
              minWidth: 'auto',
            }}
          >
            ← Voltar ao login
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default Forgot;
